$(document).ready(function() {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");

    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");


      $(close_btn).on("click", () => {
				parent_section.hide();
				document.body.classList.add("announcement-hide");
			});
    });
  }

  document.querySelectorAll('.announcement-bar__scroller').forEach(function(scroller) {
    var inner = scroller.querySelector('.announcement-bar__scroller-inner');
    if (!inner) return;
    var slides = inner.querySelectorAll('.announcement-bar__slide');
    if (slides.length <= 1) return;

    var interval = parseInt(scroller.dataset.scrollInterval, 10) || 4000;
    var current = 0;

    // Clone the first slide and append it so the loop always scrolls upward
    inner.appendChild(slides[0].cloneNode(true));

    setInterval(function() {
      current++;
      inner.style.transform = 'translateY(calc(-' + current + ' * var(--announcement-height)))';

      // When the clone (past the last real slide) is shown, snap silently back to the real first
      if (current === slides.length) {
        setTimeout(function() {
          inner.style.transition = 'none';
          current = 0;
          inner.style.transform = 'translateY(0)';
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              inner.style.transition = '';
            });
          });
        }, 650);
      }
    }, interval);
  });
});
